import { SVGProps } from 'react';

/** Expand icon: two diagonal outward arrows. Uses `currentColor`. */
export const MaximiseArrowsIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      data-icon
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Top-left corner arrow */}
      <path d="M2 6 V2 H6" />
      <path d="M2 2 L7 7" />
      {/* Bottom-right corner arrow */}
      <path d="M14 10 V14 H10" />
      <path d="M14 14 L9 9" />
    </svg>
  );
};
